import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.GetRemindersOnRequest;
const ACTIONS    = [
  ActionType.GetRemindersOnRequest,
  ActionType.GetRemindersOnResponse,
  ActionType.GetRemindersOnError,
];


type Payload = boolean;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to get the state of whether or not the user has set email reminders to 'on'
 */
export const getRemindersOnAction = (projectId: number, participantId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetRemindersOn,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ projectId, participantId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['devPlan', 'emailRemindersOn'], payload, successState);
};


export const getRemindersOnReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
